import React from 'react';
import { useTranslation } from '../contexts/LanguageContext';
import { RANK_DISPLAY, rankTierName } from './RankBadge';

function RankUpCelebration({ rankProgressUpdate, onClose }) {
    const { t } = useTranslation();
    if (!rankProgressUpdate || !rankProgressUpdate.rankChanged) return null;

    const oldDisplay = RANK_DISPLAY[rankProgressUpdate.oldTier] || RANK_DISPLAY['bronze_3'];
    const newDisplay = RANK_DISPLAY[rankProgressUpdate.rankTier] || RANK_DISPLAY['bronze_3'];
    const oldName = rankTierName(t, rankProgressUpdate.oldTier);
    const newName = rankTierName(t, rankProgressUpdate.rankTier);

    return (
        <div className="rank-up-overlay" onClick={onClose}>
            <div className="rank-up-content" onClick={(e) => e.stopPropagation()}>
                <button
                    className="victory-close-button"
                    onClick={onClose}
                    aria-label={t('common.close')}
                >
                    <i className="fa fa-times"></i>
                </button>

                <div className="rank-up-icons">
                    <div className="rank-up-old" style={{ color: oldDisplay.color }}>
                        <i className={`fas ${oldDisplay.icon}`} />
                        <span>{oldName}</span>
                    </div>
                    <div className="rank-up-arrow">
                        <i className="fa fa-arrow-right" />
                    </div>
                    <div className="rank-up-new" style={{ color: newDisplay.color }}>
                        <i className={`fas ${newDisplay.icon}`} />
                        <span>{newName}</span>
                    </div>
                </div>

                <h2 className="rank-up-title" style={{ color: newDisplay.color }}>
                    {t('rank.rankUp')}
                </h2>
                <p className="rank-up-text">
                    {t.rich('rank.promotedTo', { b: <strong style={{ color: newDisplay.color }} /> }, { tier: newName })}
                </p>

                <button className="rank-up-dismiss" onClick={onClose}>
                    {t('rank.continuePlaying')}
                </button>
            </div>
        </div>
    );
}

export default RankUpCelebration;
